/** @format */

import {
  CUSTOMER_SUCCESS,
  ROADFLEX_CUSTOMER_SUCCESS,
} from "@roadflex/constants";
import { HeadSeo } from "@roadflex/react-components-www";
import AlternateComponent from "../../components/common-components/alternate";
import BigBanner from "../../components/common-components/big-banner/big-banner";
import CallToAction from "../../components/common-components/call-to-action/call-to-action";
import SavingsAndResults from "../../components/partners/common-components/savings-and-results/savings-and-results";

export function CustomerSuccessPage() {
  const keywordList: string[] = ["RoadFlex"];
  return (
    <>
      <HeadSeo
        url="${NEXT_PUBLIC_WWW_URL}/customer-success"
        title="RoadFlex - Customer Success"
        description="The Support That Your Fleet Deserves. No Charge."
        keywords={keywordList}
      />
      <BigBanner
        heading="The Support That Your Fleet Deserves. No Charge."
        details="RoadFlex members spend less time worrying about tracking expenses and more time increasing profits"
        includeCallToAction={true}
      ></BigBanner>
      <SavingsAndResults
        scorecards={CUSTOMER_SUCCESS}
        showHeader={false}
        showFooter={true}
        customerSuccessPage={true}
      ></SavingsAndResults>
      <AlternateComponent
        features1={ROADFLEX_CUSTOMER_SUCCESS}
        backgroundColor="stary-background"
        icon="CheckCircleGreenIcon"
      />
      <CallToAction></CallToAction>
    </>
  );
}

export default CustomerSuccessPage;
